import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { BUNDLE_TAB_PANEL_BG } from './bundleFormTheme';

interface Props {
  description: string;
  activeState: boolean;
  onActiveStateChange: (value: boolean) => void;
}

const statusToggleSx = {
  bgcolor: 'common.white',
  p: 0.5,
  borderRadius: 1,
  '& .MuiToggleButtonGroup-grouped': {
    border: 0,
    '&:not(:first-of-type)': {
      borderLeft: 0,
      marginLeft: 0,
    },
  },
  '& .MuiToggleButton-root': {
    px: 2.5,
    py: 0.75,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 1.4,
    borderRadius: '6px !important',
    border: 'none',
    color: 'text.secondary',
    bgcolor: 'transparent',
    '&.Mui-selected': {
      bgcolor: '#22c55e',
      color: 'common.white',
      boxShadow: '0px 2px 4px rgba(0,0,0,0.05)',
      '&:hover': {
        bgcolor: '#16a34a',
      },
    },
    '&:hover': {
      bgcolor: 'transparent',
    },
  },
  '& .MuiToggleButton-root[value="inactive"].Mui-selected': {
    bgcolor: 'error.main',
    color: 'common.white',
    '&:hover': {
      bgcolor: 'error.dark',
    },
  },
};

const BundleTabStatusBar = ({
  description,
  activeState,
  onActiveStateChange,
}: Props) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    justifyContent='space-between'
    alignItems={{ xs: 'stretch', sm: 'center' }}
    spacing={{ xs: 1.5, sm: 2 }}
    sx={{
      py: 2,
      px: { xs: 0, sm: 0 },
      borderBottom: '1px solid',
      borderColor: 'divider',
      bgcolor: BUNDLE_TAB_PANEL_BG,
      minWidth: 0,
    }}
  >
    <Typography
      variant='body2'
      sx={{
        color: 'primary.main',
        flex: 1,
        minWidth: 0,
        pr: { sm: 2 },
      }}
    >
      {description}
    </Typography>

    <Stack
      direction='row'
      alignItems='center'
      spacing={1}
      sx={{
        flexShrink: 0,
        alignSelf: { xs: 'flex-start', sm: 'center' },
      }}
    >
      <Typography
        variant='body2'
        sx={{ color: 'text.secondary', fontWeight: 500, whiteSpace: 'nowrap' }}
      >
        Status:
      </Typography>
      <ToggleButtonGroup
        exclusive
        size='small'
        value={activeState ? 'active' : 'inactive'}
        onChange={(_, value) => {
          if (value) onActiveStateChange(value === 'active');
        }}
        sx={{
          ...statusToggleSx,
          '& .MuiToggleButton-root': {
            ...statusToggleSx['& .MuiToggleButton-root'],
            px: { xs: 2, sm: 2.5 },
            whiteSpace: 'nowrap',
          },
        }}
      >
        <ToggleButton value='active'>Active</ToggleButton>
        <ToggleButton value='inactive'>Inactive</ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  </Stack>
);

export default BundleTabStatusBar;
